// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h3d0","tabsBox":"styles_tabsBox__3OyrQ","createButton":"styles_createButton__2To7s"};